<template>
  <div v-if="isValidObject(pagination)" class="table__info">
    <strong>{{ firstItemNumber }}</strong>-<strong class="mr-1">{{ lastItemNumber }}</strong> {{ $t('Common.of') }} <strong class="ml-1">{{ pagination.totalElements | formatNumber }}</strong> <span class="ml-1">{{ $t(`Common.tableInfo.${type}`) }}</span>
  </div>
</template>

<script>
import { isValidObject } from 'corp-front-vue-commons/src/utils/functions'
import { formatNumber } from 'utils/functions'

export default {
  name: 'TableInfo',
  props: {
    type: {
      type: String
    },
    pagination: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    firstItemNumber () {
      const { currentPage, itemsPerPage } = this.pagination
      const calc = (currentPage * itemsPerPage) - itemsPerPage + 1
      const item = currentPage === 1 ? 1 : calc
      return formatNumber(item)
    },

    lastItemNumber () {
      const { currentPage, itemsPerPage, totalElements } = this.pagination
      const calc = currentPage * itemsPerPage
      const item = calc > totalElements ? totalElements : calc
      return formatNumber(item)
    }
  },
  methods: {
    isValidObject (val) {
      return isValidObject(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.table__info {
  align-items: center;
  background-color: $white;
  border-bottom: 1px solid $gray-4;
  display: flex;
  font-size: $base-font-size - 1px;
  height: 43px;
  padding: 8px 16px;
}
</style>
